import React from 'react';
import { FirstImpressionsProvider } from './use-first-impressions-state';
import { SlackPromoConfluenceView } from './slack-promo-confluence-view';
import { SignUpLayoutContainerProps } from '../../../sign-up-layout-container';

export function SlackPromoConfluenceScreen(props: SignUpLayoutContainerProps) {
  return (
    <FirstImpressionsProvider {...props}>
      <SlackPromoConfluenceView {...props} />
    </FirstImpressionsProvider>
  );
}
